import { Controller } from "stimulus";

export default class extends Controller {
  submit() {
    localStorage.setItem("video_call_open", false);
    sessionStorage.setItem("video_call_open", false);
  }
}
